
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const TableSpecimen = makeShortcode("TableSpecimen");
const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
<style>{`
  table:not([class]) {
     margin-top: 1rem;
     font-size: 0.875rem;
     cell-spacing: none;
     border-spacing: 0;
     border-collapse: collapse;
  }

  table:not([class]) tr:nth-child(2n) {
    background: #eee;
  }

  table:not([class]) td, table:not([class]) th {
    border-bottom: #ccc 1px solid;
    margin-top: 0;
    padding: 0.25rem 0.5rem;
  }

  table:not([class]) tr {
    margin-bottom: 0;
  }

  li > code {
    font-size: 0.875rem;
  }
`}</style>
<p>{`Visualize fetches and parses RDF cubes. For easier consumption by the charts, we
transform some of the terms.`}</p>
<p>{`Most of the parsing is done in
`}<a parentName="p" {...{
        "href": "https://github.com/visualize-admin/visualization-tool/blob/main/app/rdf/parse.ts"
      }}>{`rdf/parse.ts`}</a>{`,
this file can serve as a reference. Do not hesitate to
`}<a parentName="p" {...{
        "href": "https://github.com/visualize-admin/visualization-tool/issues"
      }}>{`post an issue`}</a>{` if
you find this documentation incomplete.`}</p>
<p>{`See also `}<a parentName="p" {...{
        "href": "https://zazuko.github.io/rdf-cube-schema/"
      }}>{`the RDF cube schema`}</a>{` for
more information on the RDF cube schema specification.`}</p>
<h3>{`Cube Validator`}</h3>
<p>{`To be correctly displayed inside Visualize, your cube needs to have some
attributes, some which are part of the cube specification, other which are
specific to Visualize. To help you understand why a cube does not behave as
expected, `}<a parentName="p" {...{
        "href": "https://cube-validator.lindas.admin.ch/select"
      }}>{`the Cube Validator`}</a>{`
can help you: it provides a list of checks against a cube that you can use to
troubleshoot.`}</p>
<p>{`It can be used to understand:`}</p>
<ul>
<li parentName="ul">{`Why a cube does not appear on the search`}</li>
<li parentName="ul">{`Why a cube cannot be loaded inside Visualize`}</li>
</ul>
<h3>{`Cube`}</h3>
<table>
<thead parentName="table">
<tr parentName="thead">
<th parentName="tr" {...{
            "align": "left"
          }}>{`RDF`}</th>
<th parentName="tr" {...{
            "align": "left"
          }}>{`Visualize`}</th>
</tr>
</thead>
<tbody parentName="table">
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`?cube dcterms:identifier ?value`}</inlineCode></td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`identifier`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`?cube schema:name ?value`}</inlineCode></td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`title`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`?cube schema:description ?value`}</inlineCode></td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`description`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`?cube schema:version ?value`}</inlineCode></td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`version`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`?cube schema:creativeWorkStatus adminVocabulary:CreativeWorkStatus/Published`}</inlineCode></td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`isPublished`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`?cube schema:datePublished ?value`}</inlineCode></td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`datePublished`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`?cube dcat:theme ?value`}</inlineCode></td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`themes`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`?cube dcterms:creator ?value`}</inlineCode></td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`creator`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`?cube dcat:contactPoint ?cp`}</inlineCode><br /><inlineCode parentName="td">{`?cp vcard:fn ?value`}</inlineCode></td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`contactPoint.name`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`?cube dcat:contactPoint ?cp`}</inlineCode><br /><inlineCode parentName="td">{`?cp vcard:hasEmail ?value`}</inlineCode></td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`contactPoint.email`}</inlineCode></td>
</tr>
</tbody>
</table>
<h3>{`Dimensions`}</h3>
<h4>{`Key / Measure`}</h4>
<p>{`Values inside key dimensions must `}<em parentName="p">{`uniquely identify a row`}</em>{`. For this reason,
and because visualize does not deal with aggregation, key dimensions must either
be `}<strong parentName="p">{`encoded`}</strong>{` or `}<strong parentName="p">{`part of a filter`}</strong>{`.`}</p>
<table>
<thead parentName="table">
<tr parentName="thead">
<th parentName="tr" {...{
            "align": "left"
          }}>{`RDF`}</th>
<th parentName="tr" {...{
            "align": "left"
          }}>{`Visualize`}</th>
</tr>
</thead>
<tbody parentName="table">
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`?dimension a cube:KeyDimension`}</inlineCode></td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`dim.isKeyDimension = true`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`?dimension a cube:MeasureDimension`}</inlineCode></td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`dim.isMeasureDimension = true`}</inlineCode></td>
</tr>
</tbody>
</table>
<h4>{`Scale type`}</h4>
<table>
<thead parentName="table">
<tr parentName="thead">
<th parentName="tr" {...{
            "align": "left"
          }}>{`RDF`}</th>
<th parentName="tr" {...{
            "align": "left"
          }}>{`Visualize`}</th>
</tr>
</thead>
<tbody parentName="table">
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`?dimension qudt:scaleType qudt:NominalScale`}</inlineCode></td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`dim.scaleType = "Nominal"`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`?dimension qudt:scaleType qudt:OrdinalScale`}</inlineCode></td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`dim.scaleType = "Ordinal"`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`?dimension qudt:scaleType qudt:RatioScale`}</inlineCode></td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`dim.scaleType = "Ratio"`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`?dimension qudt:scaleType qudt:IntervalScale`}</inlineCode></td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`dim.scaleType = "Interval"`}</inlineCode></td>
</tr>
</tbody>
</table>
<h4>{`Data type`}</h4>
<ul>
<li parentName="ul"><inlineCode parentName="li">{`isNumerical`}</inlineCode></li>
</ul>
<table>
<thead parentName="table">
<tr parentName="thead">
<th parentName="tr" {...{
            "align": "left"
          }}>{`RDF`}</th>
<th parentName="tr" {...{
            "align": "left"
          }}>{`Visualize`}</th>
</tr>
</thead>
<tbody parentName="table">
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`?dimension shacl:datatype xsd:int`}</inlineCode></td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`dim.isNumerical = true`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`?dimension shacl:datatype xsd:integer`}</inlineCode></td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`dim.isNumerical = true`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`?dimension shacl:datatype xsd:decimal`}</inlineCode></td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`dim.isNumerical = true`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`?dimension shacl:datatype xsd:float`}</inlineCode></td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`dim.isNumerical = true`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`?dimension shacl:datatype xsd:double`}</inlineCode></td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`dim.isNumerical = true`}</inlineCode></td>
</tr>
</tbody>
</table>
<p>{`ℹ️ At the moment, `}<inlineCode parentName="p">{`isNumerical`}</inlineCode>{` property is used when sorting and formatting
dimension values in some specific cases (e.g. when NominalDimension is
numerical). Generally, this property is a "last resort property", as numerical
dimensions are usually treated as `}<inlineCode parentName="p">{`NumericalMeasure`}</inlineCode>{`s based on
`}<inlineCode parentName="p">{`https://cube.link/MeasureDimension`}</inlineCode>{` property.`}</p>
<ul>
<li parentName="ul"><inlineCode parentName="li">{`isLiteral`}</inlineCode></li>
</ul>
<table>
<thead parentName="table">
<tr parentName="thead">
<th parentName="tr" {...{
            "align": "left"
          }}>{`RDF`}</th>
<th parentName="tr" {...{
            "align": "left"
          }}>{`Visualize`}</th>
</tr>
</thead>
<tbody parentName="table">
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`?dimension shacl:nodeKind ?shacl:Literal`}</inlineCode></td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`dim.isLiteral = true`}</inlineCode></td>
</tr>
</tbody>
</table>
<p><inlineCode parentName="p">{`True`}</inlineCode>{` when the dimension has `}<inlineCode parentName="p">{`shacl:nodeKind`}</inlineCode>{` of `}<inlineCode parentName="p">{`shacl:Literal`}</inlineCode>{`. Non literal
dimensions (`}<inlineCode parentName="p">{`shacl:IRI`}</inlineCode>{`) are also called `}<em parentName="p">{`Shared dimensions`}</em>{`, and their values
will be fetched outside of the cube.`}</p>
<h4>{`Data kind`}</h4>
<table>
<thead parentName="table">
<tr parentName="thead">
<th parentName="tr" {...{
            "align": "left"
          }}>{`RDF`}</th>
<th parentName="tr" {...{
            "align": "left"
          }}>{`Visualize`}</th>
</tr>
</thead>
<tbody parentName="table">
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`?dimension cube:meta/dataKind time:GeneralDateTimeDescription`}</inlineCode></td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`dim.dataKind = "Time"`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`?dimension cube:meta/dataKind schema:GeoCoordinates`}</inlineCode></td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`dim.dataKind = "GeoCoordinates"`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`?dimension cube:meta/dataKind schema:GeoShape`}</inlineCode></td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`dim.dataKind = "GeoShape"`}</inlineCode></td>
</tr>
</tbody>
</table>
<p>{`ℹ️ Temporal dimensions can be used to animate the chart. `}<strong parentName="p">{`Important note`}</strong>{`:
time can also be ordinal if the scale type is set to `}<inlineCode parentName="p">{`Ordinal`}</inlineCode>{`!`}</p>
<p>{`ℹ️ GeoCoordinates dimensions can be shown on a map as `}<em parentName="p">{`points`}</em></p>
<p>{`ℹ️ GeoShape dimensions can be shown on a map as `}<em parentName="p">{`shapes`}</em></p>
<h4>{`Values`}</h4>
<p>{`The `}<inlineCode parentName="p">{`sh:in`}</inlineCode>{` predicate on the dimension is used to attach what values are
available on the dimension. It is used by visualize as an optimization to list
the values that are available on the dimension. This list of possible values can
be used for example on dimension filters, or inside the legend.`}</p>
<ul>
<li parentName="ul">{`It is provided automatically by `}<inlineCode parentName="li">{`cube-creator`}</inlineCode>{` if the number of distinct
values is inferior to `}<inlineCode parentName="li">{`100`}</inlineCode>{`.`}</li>
<li parentName="ul">{`If this property is not present, visualize dynamically loads all distinct
values from the dimension, which results in poorer performance than if the
values are present.`}</li>
</ul>
<h4>{`Currencies`}</h4>
<p>{`If the dimension is related to a currency (`}<inlineCode parentName="p">{`?dimension a qudt:CurrencyUnit`}</inlineCode>{`),
when the values are displayed, we use the currency information to show the
correct number of decimals for the value.`}</p>
<ul>
<li parentName="ul">{`CHF has currency exponent 2, so we will show `}<em parentName="li">{`at least`}</em>{` 2 decimals, adding
trailing zeroes if necessary`}</li>
<li parentName="ul">{`YEN has currency exponent 0, so we would not add trailing zeroes`}</li>
<li parentName="ul">{`Additionally, if the dimension's dataType indicates it contains rounded values
(`}<inlineCode parentName="li">{`?dim sh:datatype xsd:int`}</inlineCode>{` or `}<inlineCode parentName="li">{`?dim sh:datatype xsd:integer`}</inlineCode>{`), we do not use
this logic and will show the values without decimals`}</li>
</ul>
<h4>{`Related dimensions`}</h4>
<h5>{`Standard error`}</h5>
<p>{`A dimension can indicate that it is contains standard error values for another
dimension.`}</p>
<p>{`ℹ️ Standard error dimensions are not shown in the left filters.`}</p>
<table>
<thead parentName="table">
<tr parentName="thead">
<th parentName="tr" {...{
            "align": "left"
          }}>{`RDF`}</th>
<th parentName="tr" {...{
            "align": "left"
          }}>{`Visualize`}</th>
</tr>
</thead>
<tbody parentName="table">
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`?dim `}</inlineCode>{`cube/meta/dimensionRelation`}<inlineCode parentName="td">{` ?relationNode`}</inlineCode><br /><inlineCode parentName="td">{`?relationNode a <https://cube.link/relation/StandardError>`}</inlineCode></td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`dimension.related = { type: "StandardError", iri: "https://dimension-containing-values"}`}</inlineCode></td>
</tr>
</tbody>
</table>
<h4>{`Possible chart types`}</h4>
<p>{`After parsing, we can determine the type of our dimension. Conditions are
checked one after the other.`}</p>
<ul>
<li parentName="ul"><strong parentName="li">{`Ordinal Measure`}</strong>{` if `}<inlineCode parentName="li">{`isMeasureDimension = true and scaleType = "Ordinal"`}</inlineCode>{`,
else`}</li>
<li parentName="ul"><strong parentName="li">{`Numerical Measure`}</strong>{` if
`}<inlineCode parentName="li">{`isMeasureDimension = true and scaleType != "Ordinal"`}</inlineCode>{`, else`}</li>
<li parentName="ul"><strong parentName="li">{`Standard Error Dimension`}</strong>{` if any of the related dimensions has
`}<inlineCode parentName="li">{`StandardError`}</inlineCode>{` type, else`}</li>
<li parentName="ul"><strong parentName="li">{`Confidence Upper Bound Dimension`}</strong>{` if any of the related dimensions has
`}<inlineCode parentName="li">{`ConfidenceUpperBound`}</inlineCode>{` type, else`}</li>
<li parentName="ul"><strong parentName="li">{`Confidence Lower Bound Dimension`}</strong>{` if any of the related dimensions has
`}<inlineCode parentName="li">{`ConfidenceLowerBound`}</inlineCode>{` type, else`}</li>
<li parentName="ul"><strong parentName="li">{`Temporal Entity Dimension`}</strong>{` if
`}<inlineCode parentName="li">{`dataKind = "Time" and scaleType = "Ordinal" and (timeUnit = "Month" or timeUnit = "Year")`}</inlineCode>{`,
else`}</li>
<li parentName="ul"><strong parentName="li">{`Temporal Ordinal Dimension`}</strong>{` if
`}<inlineCode parentName="li">{`dataKind = "Time" and scaleType = "Ordinal"`}</inlineCode>{`, else`}</li>
<li parentName="ul"><strong parentName="li">{`Temporal Dimension`}</strong>{` if `}<inlineCode parentName="li">{`dataKind = "Time" and scaleType != "Ordinal"`}</inlineCode>{`, else`}</li>
<li parentName="ul"><strong parentName="li">{`GeoCoordinates Dimension`}</strong>{` if `}<inlineCode parentName="li">{`dataKind = "GeoCoordinates"`}</inlineCode>{`, else`}</li>
<li parentName="ul"><strong parentName="li">{`GeoShapes Dimension`}</strong>{` if `}<inlineCode parentName="li">{`dataKind = "GeoShape"`}</inlineCode>{`, else`}</li>
<li parentName="ul"><strong parentName="li">{`Ordinal Dimension`}</strong>{` if `}<inlineCode parentName="li">{`scaleType = "Ordinal"`}</inlineCode>{`, else`}</li>
<li parentName="ul"><strong parentName="li">{`Nominal Dimension`}</strong>{` if none of the above condition have been fulfilled`}</li>
</ul>
<p>{`We can regroup some of these dimensions, for easier business logic:`}</p>
<ul>
<li parentName="ul"><strong parentName="li">{`Ordinal Measure`}</strong>{` and `}<strong parentName="li">{`Numerical Measure`}</strong>{` are `}<strong parentName="li">{`Measures`}</strong>{`.`}</li>
<li parentName="ul"><strong parentName="li">{`Ordinal`}</strong>{` and `}<strong parentName="li">{`Nominal`}</strong>{` are `}<strong parentName="li">{`Categorical Dimensions`}</strong>{`.`}</li>
<li parentName="ul"><strong parentName="li">{`GeoCoordinates`}</strong>{` and `}<strong parentName="li">{`GeoShapes`}</strong>{` are `}<strong parentName="li">{`Geo Dimensions`}</strong>{`.`}</li>
</ul>
<p>{`To enable particular chart types the following conditions have to be met:`}</p>
<TableSpecimen columns={["Chart Type", "Conditions"]} rows={[{
      "Chart Type": "Table",
      Conditions: `- None`
    }, {
      "Chart Type": "Column",
      Conditions: `- 1 or more **Numerical Measures**
- 1 or more **Categorical** or **Geo** or **Temporal (Ordinal) Dimensions**`
    }, {
      "Chart Type": "Lines",
      Conditions: `- 1 or more **Numerical Measures**
- 1 or more **Temporal Dimensions**`
    }, {
      "Chart Type": "Areas",
      Conditions: `- 1 or more **Numerical Measures**
- 1 or more **Temporal Dimensions**`
    }, {
      "Chart Type": "Pie",
      Conditions: `- 1 or more **Numerical Measures**
- 1 or more **Categorical** or **Geo** or **Temporal (Ordinal) Dimensions**`
    }, {
      "Chart Type": "Scatterplot",
      Conditions: "- 2 or more **Numerical Measures**"
    }, {
      "Chart Type": "Maps",
      Conditions: `- 1 or more **Measures**
- 1 or more **Geo Dimensions**`
    }]} mdxType="TableSpecimen" />
<h2>{`Update constraints`}</h2>
<p>{`When updating a cube, you have to follow a number of rules to make sure that the
charts that rely on those cubes will continue to work.`}</p>
<ul>
<li parentName="ul">
<p parentName="li">{`Structure of a dimension should not be changed, otherwise, if a filter relies
on the dimension, it might not work anymore. Here are the properties of a
dimension that should not change:`}</p>
<ul parentName="li">
<li parentName="ul"><inlineCode parentName="li">{`a`}</inlineCode>{`: Dimension type`}</li>
<li parentName="ul"><inlineCode parentName="li">{`qudt:hasUnit`}</inlineCode>{`: Unit`}</li>
<li parentName="ul"><inlineCode parentName="li">{`qudt:scaleType`}</inlineCode>{`: Scale type`}</li>
<li parentName="ul"><inlineCode parentName="li">{`shacl:datatype`}</inlineCode>{`: Data type`}</li>
<li parentName="ul"><inlineCode parentName="li">{`meta:dataKind`}</inlineCode>{`: Data kind`}</li>
</ul>
<p parentName="li">{`Please refer to the
`}<a parentName="p" {...{
            "href": "https://zazuko.github.io/rdf-cube-schema/#properties-0"
          }}>{`RDF Cube Schema`}</a>{` to
learn more about those attributes.`}</p>
</li>
<li parentName="ul">
<p parentName="li">{`Similarly, a dimension should not be removed (same reason: if it is used in a
chart filter, the filter will not be correct when the dimension is removed)`}</p>
</li>
<li parentName="ul">
<p parentName="li">{`Observations should not be removed, otherwise a chart that shows only those
observations via a data filter will not show anything anymore.`}</p>
</li>
</ul>
<p>{`If you need to do any of those things, you should create a new cube.`}</p>
<p>{`If your cube is in draft, you can ignore those rules as chart owners know that
they are relying on something that is not finished and that can change.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;